import PropTypes from 'prop-types';
import React from 'react';
import Rating from 'react-rating';

import { StarEmpty, StarFull } from '../../icons';

import './TestimonialItem.scss';

const TestimonialItem = ({ name, text, rating }) => (
  <div className="testimonial">

    {!!rating && (
      <div className="testimonial-rating-holder">
        <Rating
          initialRating={rating}
          readonly
          emptySymbol={<StarEmpty className="rating-star" style={{ fontSize: '1.3rem' }} />}
          fullSymbol={<StarFull className="rating-star" style={{ fontSize: '1.3rem' }} />}
        />
      </div>
    )}

    <p className="text text-muted">{text}</p>

    <p className="name">
      {name}
    </p>
  </div>
);

TestimonialItem.propTypes = {
  name: PropTypes.string.isRequired,
  rating: PropTypes.number,
  text: PropTypes.string.isRequired,
};

TestimonialItem.defaultProps = {
  rating: null,
};

export default TestimonialItem;
